/* NEXRA — reveal each main section as it scrolls into view.
   Fails safe: if motion is reduced, IntersectionObserver is missing, or anything
   goes wrong, every section is shown immediately so content is never lost. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var supportsIO = 'IntersectionObserver' in window;

  function sections() {
    return document.querySelectorAll('#MainContent > .shopify-section');
  }

  function revealAll() {
    sections().forEach(function (s) { s.classList.add('nexra-in'); });
  }

  function init() {
    if (reduce || !supportsIO) {
      revealAll();
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('nexra-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -6% 0px' });

    sections().forEach(function (s) { observer.observe(s); });

    // Safety net: never leave a section hidden.
    setTimeout(revealAll, 4000);
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
